import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function RadioGroupIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <circle cx="8" cy="4.25" r="2.55" stroke="currentColor" strokeWidth="1.25" fill="none" />
      <circle cx="8" cy="4.25" r="1" fill="currentColor" />
      <circle cx="8" cy="11.75" r="2.55" stroke="currentColor" strokeWidth="1.25" fill="none" />
    </SvgIcon>
  );
}
